import React, { useMemo } from "react";
import type { FC } from "react";

import cn from "classnames";

import { extractProps } from "../../utils/react";
import { DEFAULT_MAX_QUANTITY } from "../Counter/Counter";
import { calcQuantity } from "../Counter/utils";

import type { CounterInlineProps } from "./types";

import classes from "./CounterInline.styl";

export const COUNTER_INLINE_TEST_ID = "counter-inline-test-id";
const COUNTER_INLINE_DISPLAY_NAME = "CounterInline";

/**
 * Базовый компонент, фокусирующий на себе внимание пользователя и информирующий о количестве информации.
 * Может отображать строчку число-буквенных значений, принимает в себя размер и цвет текста.
 *
 * <a href="https://www.figma.com/design/vTg3KAvmAXA9LigeyiqCWL/%F0%9F%92%A0-Base-Components?m=auto&node-id=4047-12018&t=sjRhBAeLUfZwLDvH-1" target="_blank">Спека</a>
 * @constructor
 */
export const CounterInline: FC<CounterInlineProps> = (props): JSX.Element => {
    const { customColorsStyles, customVarsStyles, currentProps } = extractProps(
        props,
        ["customColorsStyles", "customVarsStyles"],
    );

    const {
        view = "primary",
        quantity,
        maxQuantity = DEFAULT_MAX_QUANTITY,
        "data-tsid": tsid,
    } = currentProps;

    const currentQuantity = useMemo(
        () => calcQuantity(quantity, maxQuantity),
        [quantity, maxQuantity],
    );

    const counterClasses = cn(
        classes["counter-inline"],
        {
            [classes[`__style-${view}`]]: view,
        },
        customColorsStyles,
        customVarsStyles,
    );

    return (
        <span
            className={counterClasses}
            data-tsid={tsid}
            data-uikit={COUNTER_INLINE_DISPLAY_NAME}
        >
            {currentQuantity}
        </span>
    );
};

CounterInline.displayName = COUNTER_INLINE_DISPLAY_NAME;

export default CounterInline;
